/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'CREATE_CONNECTED_BANK_ACCOUNT',
  'LOAD_CONNECTED_BANK_ACCOUNTS',
  'REVOKE_ACCESS',
  'APPROVE',
  'REJECT',
  'GET_CONNECTED_BANK_ACCOUNT',
]);

export const Status = enumerate([
  'PENDING',
  'APPROVED',
  'REVOKED',
]);



// WEBPACK FOOTER //
// ./src/payments/constants/ConnectedBankAccountConstants.js